// Client-Service für die Exchange-API-Endpoints.
// Alle Aufrufe sind authentifiziert via Firebase-ID-Token (siehe authHeader).
//
// Konvention für Fehler:
//   - HTTP 4xx/5xx → throw new ApiError(message, { status, requiresUpgrade })
//   - Netzwerkfehler → throw new ApiError(message, { status: 0 })
// Caller fängt ApiError ab und entscheidet (Toast vs. Pricing-Modal).

import { authHeader } from './authHeader';

export class ApiError extends Error {
  constructor(message, { status = 0, requiresUpgrade = false } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.requiresUpgrade = requiresUpgrade;
  }
}

async function post(path, body) {
  let res;
  try {
    res = await fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(await authHeader()),
      },
      body: JSON.stringify(body),
    });
  } catch (err) {
    throw new ApiError('Netzwerkfehler — bitte Internetverbindung prüfen.', { status: 0 });
  }
  let data = {};
  try { data = await res.json(); } catch { /* leerer Body ist okay */ }

  if (!res.ok) {
    throw new ApiError(data.error || `Fehler ${res.status}`, {
      status: res.status,
      requiresUpgrade: !!data.requiresUpgrade,
    });
  }
  return data;
}

// ── Public API ───────────────────────────────────────────────────────────────

export function testConnection({ exchangeId, apiKey, secret, passphrase }) {
  return post('/api/exchange-connect', {
    action: 'test', exchangeId, apiKey, secret, passphrase: passphrase || null,
  });
}

export function saveConnection({ exchangeId, label, apiKey, secret, passphrase }) {
  return post('/api/exchange-connect', {
    action: 'save', exchangeId, label: label || null,
    apiKey, secret, passphrase: passphrase || null,
  });
}

export async function listConnections() {
  const data = await post('/api/exchange-connect', { action: 'list' });
  return data.connections || [];
}

export function deleteConnection(connectionId) {
  return post('/api/exchange-connect', { action: 'delete', connectionId });
}

export function syncConnection(connectionId, { fullResync = false } = {}) {
  return post('/api/exchange-sync', { connectionId, fullResync });
}
